export default __webpack_public_path__ + "static/media/hero-axios.3354a3f9.webp";